import emptyIdApi from 'app/store/emptyIdApi';

const rootReducer = {
  api: emptyIdApi.reducer,
};

export default rootReducer;
